module.exports = __webpack_public_path__ + "static/ayanlowo-4c8a377a23678a7ff2340bc1e428d273.png";